const settingIntialState = {
  isDarkTheme: false,
  recentSearchList: [],
  sectionId: null,
};

function settingsReducer(state = settingIntialState, action) {
  switch (action.type) {
    case "TOGGLE_THEME":
      return {
        ...state,
        isDarkTheme: action.payload,
      };

    case "RECENT_SEARCH": {
      return {
        ...state,
        recentSearchList: action.payload,
      };
    }

    case "SECTION_ID": {
      return {
        ...state,
        sectionId: action.payload,
      };
    }

    default:
      return state;
  }
}

const storyReducerState = {
  wruData: {},
  fitData: {},
};

const storyReducer = (state = storyReducerState, action) => {
  switch (action.type) {
    case "STORY_WRU_DATA":
      return {
        ...state,
        wruData: {
          ...state.wruData,
          [action.storyId]: action.payload,
        },
      };
    case "STORY_WRU_FIT_DATA":
      return {
        ...state,
        fitData: {
          ...state.fitData,
          [action.storyId]: action.payload,
        },
      };
    default:
      return state;
  }
};

const userReducerState = {
  myPlans: [],
  isActivePlan: 0,
  isPlansLoaded: false,
};

const userReducer = (state = userReducerState, action) => {
  switch (action.type) {
    case "SET_USER_PLANS": {
      const isActivePlan = action.plans.subscriptions.filter((plan) => plan.active).length;
      return {
        ...state,
        myPlans: action.plans.subscriptions || [],
        isActivePlan,
        isPlansLoaded: true,
      };
    }
    case "SET_LOGOUT_STATE":
      return {
        ...state,
        isActivePlan: 0,
        myPlans: [],
        isPlansLoaded: false,
      };
    default:
      return state;
  }
};

export default {
  settingsReducer,
  storyReducer,
  userReducer,
};
